var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import XLSX from 'xlsx';
import moment from 'moment';
import { camelCase, isInteger, isString, isNumber } from 'lodash';
import { ValidationRuleType } from './types';
var ImportExcel = /** @class */ (function (_super) {
    __extends(ImportExcel, _super);
    function ImportExcel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShowPopup = false;
        _this.excelData = {
            header: undefined,
            results: undefined
        };
        return _this;
    }
    Object.defineProperty(ImportExcel.prototype, "theValidationRules", {
        get: function () {
            var rules = {};
            if (this.validationRules && this.validationRules.length) {
                this.validationRules.forEach(function (rule) {
                    rules[camelCase(rule.header)] = __assign({}, rule);
                });
            }
            return rules;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImportExcel.prototype, "canImport", {
        get: function () {
            var _this = this;
            if (this.excelData.results && this.excelData.results.length) {
                return !this.excelData.results.find(function (result) { return _this.rowHasError(result); });
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ImportExcel.prototype.openPopup = function () {
        if (!this.disabled) {
            this.isShowPopup = true;
        }
    };
    ImportExcel.prototype.closePopup = function () {
        this.isShowPopup = false;
    };
    ImportExcel.prototype.formatValue = function (value) {
        if (value && value instanceof Date) {
            return moment(value).format('DD/MM/YYYY');
        }
        return String(value);
    };
    ImportExcel.prototype.validate = function (key, value, index, originalKey, originalResults) {
        var rule = this.theValidationRules[key];
        if (this.validationRules.length && !rule) {
            return 'This. field is not valid';
        }
        if (rule) {
            if (rule.required && !value) {
                return 'This field is required';
            }
            if (value && rule.type) {
                if (rule.type === ValidationRuleType.STRING && !isString(value)) {
                    return 'This field must be String';
                }
                if (rule.type === ValidationRuleType.INTEGER && !isInteger(value)) {
                    return 'This field must be Interger Number';
                }
                if (rule.type === ValidationRuleType.NUMBER && !isNumber(value)) {
                    return 'This field must be Number';
                }
                if (rule.type === ValidationRuleType.DATE && !(value instanceof Date)) {
                    return 'This field must be Date';
                }
            }
            if (value && rule.unique) {
                var findDuplicate = originalResults.find(function (result, curIndex) {
                    var resultValue = result[originalKey];
                    return curIndex !== index && resultValue && resultValue === value;
                });
                if (findDuplicate) {
                    return 'This field has Duplicate value';
                }
            }
        }
        return undefined;
    };
    ImportExcel.prototype.rowHasError = function (result) {
        return (!!result && !!Object.values(result).find(function (theResult) { return theResult.error; }));
    };
    ImportExcel.prototype.headerHasError = function (key) {
        if (this.excelData.results && this.excelData.results.length) {
            return !!this.excelData.results.find(function (result) { return result[key].error; });
        }
        return false;
    };
    ImportExcel.prototype.generateData = function (_a) {
        var header = _a.header, results = _a.results;
        this.excelData = {
            header: header,
            results: results
        };
    };
    ImportExcel.prototype.getHeaderRow = function (sheet) {
        var headers = [];
        var range = XLSX.utils.decode_range(sheet['!ref']);
        var C = undefined;
        var R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
            /* walk every column in the range */
            var cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
            /* find the cell in the first row */
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default
            if (cell && cell.t)
                hdr = XLSX.utils.format_cell(cell);
            headers.push({
                text: hdr,
                key: camelCase(hdr)
            });
        }
        return headers;
    };
    ImportExcel.prototype.handleDragover = function (e) {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    };
    ImportExcel.prototype.handleDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        var files = e.dataTransfer.files;
        if (files.length !== 1) {
            this.$vs.notify({
                title: 'Error',
                text: 'Only support uploading one file!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
            return;
        }
        var rawFile = files[0];
        this.uploadFile(rawFile);
    };
    ImportExcel.prototype.convertValue = function (value, rawValue) {
        if (value && value instanceof Date && rawValue) {
            return moment(rawValue)
                .startOf('day')
                .toDate();
        }
        return value;
    };
    ImportExcel.prototype.readerData = function (rawFile) {
        var _this = this;
        return new Promise(function (resolve) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var _a;
                var data = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                var workbook = XLSX.read(data, {
                    type: 'array',
                    cellDates: true,
                    dateNF: 'yyyy-mm-dd'
                });
                var firstSheetName = workbook.SheetNames[0];
                var worksheet = workbook.Sheets[firstSheetName];
                var header = _this.getHeaderRow(worksheet);
                var rawResults = XLSX.utils.sheet_to_json(worksheet, {
                    raw: false,
                    blankrows: true,
                    defval: ''
                });
                var results = XLSX.utils.sheet_to_json(worksheet, {
                    blankrows: true,
                    defval: ''
                });
                var newResults = results.map(function (result, index) {
                    var newResult = {};
                    Object.keys(result).forEach(function (key) {
                        var newKey = camelCase(key);
                        var rawValue = rawResults[index][key];
                        var parseValue = result[key];
                        var value = _this.convertValue(parseValue, rawValue);
                        newResult[newKey] = {
                            value: value,
                            error: _this.validate(newKey, value, index, key, results)
                        };
                    });
                    return newResult;
                });
                _this.generateData({ header: header, results: newResults });
                resolve();
            };
            reader.readAsArrayBuffer(rawFile);
        });
    };
    ImportExcel.prototype.handleClick = function (e) {
        var files = e.target.files;
        if (files.length !== 1) {
            this.$vs.notify({
                title: 'Error',
                text: 'Only support uploading one file!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
            return;
        }
        var rawFile = files[0];
        if (!rawFile)
            return;
        this.uploadFile(rawFile);
    };
    ImportExcel.prototype.isExcel = function (file) {
        return /\.(xlsx|xls|csv)$/.test(file.name);
    };
    ImportExcel.prototype.uploadFile = function (file) {
        this.$refs['fileInput'].value = null;
        if (!this.isExcel(file)) {
            this.$vs.notify({
                title: 'Error',
                text: 'Only supports upload .xlsx, .xls, .csv suffix files',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
            return;
        }
        this.readerData(file);
    };
    ImportExcel.prototype.reset = function () {
        this.$refs['fileInput'].value = null;
        this.excelData = {
            header: undefined,
            results: undefined
        };
    };
    ImportExcel.prototype.isShowPopupChanged = function () {
        this.reset();
    };
    ImportExcel.prototype.importExcel = function () {
        var _this = this;
        if (this.canImport) {
            this.$emit('import', {
                header: this.excelData.header,
                results: this.excelData.results.map(function (result) {
                    var newResult = {};
                    Object.keys(result).forEach(function (key) {
                        var rule = _this.theValidationRules[key];
                        var theResult = result[key];
                        if (rule && !rule.required && !theResult.value) {
                            newResult[key] = __assign(__assign({}, theResult), { value: undefined });
                        }
                        else {
                            newResult[key] = __assign({}, theResult);
                        }
                    });
                    return newResult;
                })
            });
        }
    };
    __decorate([
        Prop({
            type: String,
            default: 'Import Data'
        })
    ], ImportExcel.prototype, "popupTitle", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ImportExcel.prototype, "disabled", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], ImportExcel.prototype, "validationRules", void 0);
    __decorate([
        Watch('isShowPopup')
    ], ImportExcel.prototype, "isShowPopupChanged", null);
    ImportExcel = __decorate([
        Component
    ], ImportExcel);
    return ImportExcel;
}(Vue));
export default ImportExcel;
